<template>
    <div class="room-link grow-link" :style="pos" @click="$router.push('/expo/'+expoId+'/'+info.id)">
        <span class="tooltip">{{ info.name }}</span>
        <div class="small-content" :style="dims">
            <VideoLoop :hd="false" :iframe="info.iframe"/>
        </div>
        <img class="room-img" :style="imgDims" :src="info.img">
    </div>
</template>

<script>
import VideoLoop from './room/content/VideoLoop'

export default {
    name: 'RoomLink',
    components: {
        VideoLoop
    },
    props: ['info', 'expoId'],
    computed: {
        pos() {
            return {
                top: this.info.y + 'px',
                left: this.info.x + 'px',
            }
        },
        dims() {
            return {
                width: this.info.w + 'px',
                height: this.info.w + 'px',
            }
        },
        imgDims() {
            return {
                width: (this.info.w / 3) + 'px'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../expo.scss';
</style>